// Platform's URL is derived from where this Foundations build is served, so no build-time flag is
// needed on either box: staging.* -> Platform staging, local dev -> the local Platform frontend,
// everything else -> Platform prod.
export function platformOversightUrl(hostname) {
  const host = String(hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:3008/oversight';
  if (host.startsWith('staging.')) return 'https://platform-staging.risk-aperture.com/oversight';
  return 'https://platform.risk-aperture.com/oversight';
}
